import baseUIReducer from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Reducer';
import { actionTypes } from './Actions';

const initialState = {
  visibilityMap: {},
  visibilityMapCount: {},
  backgroundWorkMap: {},
  error: null,
  message: null,
  overviewSidebarVisible: false,
  showProductParts: true,
  showStepsNavigator: true,
  showConfigurationOverview: false,
};

export default function uiReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.TOGGLE_OVERVIEW_SIDEBAR: {
      const overviewSidebarVisible = !state.overviewSidebarVisible;
      return { ...state, overviewSidebarVisible };
    }

    case actionTypes.SHOW_PRODUCT_PARTS: {
      return { ...state, showProductParts: true, showStepsNavigator: true, showConfigurationOverview: false };
    }

    case actionTypes.SHOW_CONFIGURATION_OVERVIEW: {
      return {
        ...state,
        showProductParts: false,
        showStepsNavigator: false,
        showConfigurationOverview: true,
      };
    }

    default: {
      return baseUIReducer(state, action);
    }
  }
}
